var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TextField from "@mui/material/TextField";
var OutlineContainer = /** @class */ (function (_super) {
    __extends(OutlineContainer, _super);
    function OutlineContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OutlineContainer.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx("div", __assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: this.props.children }), void 0));
        }
    });
    return OutlineContainer;
}(React.Component));
var Outline = /** @class */ (function (_super) {
    __extends(Outline, _super);
    function Outline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Outline.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx(TextField, { variant: "outlined", fullWidth: true, label: this.props.label, multiline: true, InputLabelProps: { shrink: true }, InputProps: {
                    inputComponent: OutlineContainer
                }, inputProps: { children: this.props.children } }, void 0));
        }
    });
    return Outline;
}(React.Component));
export default Outline;
